export const CONTACT_POST_REQUEST = "CONTACT_POST_REQUEST";
export const CONTACT_POST_SUCCESS = "CONTACT_POST_SUCCESS";
export const CONTACT_POST_FAILURE = "CONTACT_POST_FAILURE";